import { createSlice, createEntityAdapter } from '@reduxjs/toolkit'
import { getVendorDoctors, resetState } from './actions'
import { IDLE_STATUS, LOADING_STATUS, SUCCESS_STATUS } from '../../../constants'

export const vendorDoctorAdapter = createEntityAdapter()
const initialState = vendorDoctorAdapter.getInitialState({
  status: IDLE_STATUS,
  count: 0,
})

const vendorDoctorSlice = createSlice({
  name: 'vendorDoctors',
  initialState,
  extraReducers: builder => {
    builder.addCase(resetState, state => {
      state.count = 0
      state.status = IDLE_STATUS
      vendorDoctorAdapter.removeAll(state)
    })
    builder.addCase(getVendorDoctors.pending, state => {
      state.status = LOADING_STATUS
    })
    builder.addCase(
      getVendorDoctors.fulfilled,
      (state, { payload: { results = [], count = 0 } }) => {
        state.count = count
        vendorDoctorAdapter.setAll(state, results)
        state.status = SUCCESS_STATUS
      }
    )
  },
})

const { reducer } = vendorDoctorSlice

export default reducer
